import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import { useNotify, useRefresh } from 'react-admin'
import { ConfirmDialog } from 'shared/components/Dialog/ConfirmDialog'

import { captureExceptionIfProduction } from 'helpers/utils'
import { unRemoveEquipment } from '../../api/core'

export const UnRemoveEquipmentButton = ({ record, permissions, equipmentType }: any) => {
  const notify = useNotify()
  const refresh = useRefresh()

  if (!record || !permissions) {
    return null
  }
  return (
    <div>
      <ConfirmDialog
        handleConfirm={(): any => {
          unRemoveEquipment(record.id, equipmentType).then(() => {
            notify('Successfully UN-removed!', { type: 'success' })
            refresh()
          })
        }}
        handleError={(error) => {
          notify(error.message, { type: 'error' })
          captureExceptionIfProduction(error)
        }}
        dialogContent={
          <Typography variant="h2" align="center">
            This will UN-REMOVE this equipment. Are you sure?
          </Typography>
        }
      >
        <Button variant="contained" color="primary">
          Un-Remove
        </Button>
      </ConfirmDialog>
    </div>
  )
}
